import React, { useEffect, useState } from "react";
import iconNotification from "../../assets/media/icon-notification.svg";
import iconSearch from "../../assets/media/icon-search.svg";

import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../store/reducers/userSlice";
import userImagePlaceholder from "../../assets/media/avatar2.png";

const Header = ({ handleSearchInputChange, extraActions }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const getUserData = useSelector((state) => state.usersdata.getuserdata);
  const notifications = useSelector(
    (state) => state.notifications.notifications
  );
  const unreadCount = useSelector(
    (state) => state.notifications.unreadCount
  );

  useEffect(() => {
    dispatch(
      getUser({
        userId: user.user.id,
        userData: { accessToken: user.access_token },
      })
    );
  }, [dispatch, user]);
  return (
    <header className="header">
      {/* <div className="searchForm">
        <input
          type="text"
          onChange={handleSearchInputChange}
          placeholder="Search"
        />
        <button>
          <img src={iconSearch} alt="" />
        </button>
      </div> */}
      {extraActions}
      <div className="notification">
        <Link to={"/notification"}>
          <img src={iconNotification} alt="" />
          <span>{unreadCount}</span>
        </Link>
      </div>
      <Link to={"/profile"}>
        <img
          className="avatar"
          src={getUserData.image || userImagePlaceholder}
          alt=""
        />
      </Link>
    </header>
  );
};
export default Header;
